import { render, staticRenderFns } from "./liveData.vue?vue&type=template&id=c86539dc&scoped=true&"
import script from "./liveData.vue?vue&type=script&lang=js&"
export * from "./liveData.vue?vue&type=script&lang=js&"
import style0 from "./liveData.vue?vue&type=style&index=0&id=c86539dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86539dc",
  null
  
)

export default component.exports